import { DesignSystem } from '@/src/design-system'
import { mesaColorNames, spacing } from '@/src/common/theme'
import { StyleSheet, View } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 8,
  },
  iconContainer: {
    backgroundColor: mesaColorNames['Wide/100 #C6FFF5'],
    borderRadius: spacing['md'],
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
    width: 36,
    height: 36,
  },
  icon: {
    width: 36,
    height: 36,
  },
  column: {
    gap: 8,
  },
  left: {
    flexGrow: 1,
  },
  right: {
    alignItems: 'flex-end',
  },
  title: {
    width: 100,
    height: 16,
  },
  subtitle: {
    width: 120,
    height: 14,
  },
  points: {
    width: 100,
    height: 16,
  },
})

export function RewardsComponentsActivityFeedItemSkeleton() {
  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <DesignSystem.Skeleton.Skeleton style={styles.icon} skeletonProps={styles.icon} />
      </View>
      <View style={[styles.left, styles.column]}>
        <DesignSystem.Skeleton.Skeleton style={styles.title} skeletonProps={styles.title} />
        <DesignSystem.Skeleton.Skeleton style={styles.subtitle} skeletonProps={styles.subtitle} />
      </View>
      <View style={[styles.right, styles.column]}>
        <DesignSystem.Skeleton.Skeleton style={styles.points} skeletonProps={styles.points} />
        <DesignSystem.Skeleton.Skeleton style={styles.subtitle} skeletonProps={styles.subtitle} />
      </View>
    </View>
  )
}
